export const data = {
  DEPLOYMENT_ENV: 'development',
  NEXT_PUBLIC_SHOW_ALL_CONTENT: true,
  NEXT_PUBLIC_RENDER_NAV: false,
  NEXT_PUBLIC_RENDER_FOOTER: false,
  NEXT_PUBLIC_PRERENDER_ARTICLES: false,
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: false,
  NEXT_PUBLIC_PRERENDER_DOCS: false,
  NEXT_PUBLIC_PRERENDER_VIDEOS: false,
  NEXT_PUBLIC_DATA_REVALIDATION: true,
  NEXT_PUBLIC_DATA_REVALIDATION_SECONDS: 0,
  NEXT_PUBLIC_PREVIEW_DATA: true,
  NEXT_PUBLIC_GTM_DISABLE: true,
  NEXT_PUBLIC_ONETRUST_DISABLE: true,
}
